<template>
	<div class="descriptors">
		<div v-for="(descriptor, index) in descriptors"
			:key="`descriptor-${ index }`"
			v-html="descriptor"
			class="descriptors__descriptor"></div>
	</div>
</template>

<script>
import sampleSize from "lodash/sampleSize";

export default {
	name: "AssessmentDescriptors",
	props: {
		assessment: {
			type: Object,
			required: false,
		},
		quantity: {
			type: Number,
			default: 3,
		},
	},
	computed: {
		descriptors() {
			const descriptors = this.assessment?.teamingContent?.descriptors || [];
			const maxIndex = Math.max( 0, this.quantity - 1 );
			return sampleSize( descriptors, this.quantity )
				.filter( descriptor => !!descriptor )
				.reduce( ( all, descriptor, index ) => {
					all.push( descriptor );
					if ( index < maxIndex ) {
						// add middle dots between descriptors
						all.push( "&#9679;" );
					}
					return all;
				}, [] );
		},
	},
};
</script>

<style lang="scss" scoped>
.descriptors {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	gap: 0.5rem
}

.descriptors__descriptor {
	font-weight: 600;
}
</style>
